import React from "react"

import "./StatutePin.css"

const StatutePin = ({text}) => {

	return (
		<div className="statutePinContainer">
			{text}
		</div>
	);
}

export default StatutePin;